import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=74890d02&scoped=true&"
import script from "./live-list.vue?vue&type=script&lang=js&"
export * from "./live-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74890d02",
  null
  
)

export default component.exports